import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AvThemeToggleComponent } from '../../Shared/Components/theme-toggle/theme-toggle.component';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { AvLanguageDropdownComponent } from '../../Shared/Components/av-language-dropdown/av-language-dropdown.component';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    AvThemeToggleComponent,
    AvLanguageDropdownComponent
  ],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthComponent {
  version = environment.version;
}